import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import ReactGA from "react-ga"

import {
  MonthPicker,
  Loader,
  ModalBookingList,
  ButtonCreate,
  ModalStatus,
  ModalCrashBooking,
  ModalInformation
} from '../../../components'
import {
  ROUTE,
  CREATE_BOOKING,
  CREATE_DEFAULT,
  MODAL_STATUS,
  PERMISSION_PAGE,
  REPEAT_OPTION_STATUS,
  BOOKING_DETAIL_VIEW,
} from '../../../helpers/constants'
import { ACCOUNT, BOOKINGCALENDAR, MODAL, HOLIDAY } from '../../../reduxs'
import { checkPermission, getCalendarString, getPositionBookingCard } from '../../../helpers/functions'

import { StyleMonth } from './style'

export class Month extends Component {
  constructor(props) {
    super(props)
    const { accountReducer } = this.props
    let selectedDate = new Date(props.year, props.month - 1, props.date, 0, -new Date().getTimezoneOffset())
    if (isNaN(selectedDate.valueOf())) selectedDate = new Date()
    this.state = {
      languages: 'EN',
      limit: 500,
      trashed: false,
      ownerName: accountReducer.user.username,
      date: '',
      bookingData: [],
      itemId: '',
      bookingId: '',
      deletedReason: '',
      nameModal: '',
      selectedDate,
      dateString: null,
      headerName: null,
      descriptionName: null,
      buttonName: null,
      permission: {
        create: checkPermission(accountReducer.permission, ROUTE.CALENDAR.ACTION.CREATE)
      },
      selectedKeyRepeatOption: REPEAT_OPTION_STATUS.THIS_SCHEDULE,
      isOpenDeleteModalStepTwo: false,
      position: { x: 0, y: 0 },
    }

    //GA TrackingId
    ReactGA.initialize("UA-153387162-1")
    ReactGA.pageview("(Month) Calendar Page")
  }

  componentDidMount () {
    const { bookingcalendarAction, holidayAction, accountReducer } = this.props
    const { selectedDate } = this.state
    bookingcalendarAction.getListBooking(this.objGetParams())
    this.unlisten = this.props.history.listen((location, action) => {
      let path = location.pathname.split('/')

      if ( path[1] && path[2]  && path[1] === 'calendar' && (path[2].toLowerCase() === 'month' || path[2].toLowerCase() === 'year')) bookingcalendarAction.getListBooking(this.objGetParams2(location))
    })
    const startDateString = [selectedDate.getFullYear(), '01', '01'].join('-')
    const endDateString = [selectedDate.getFullYear(), '12', '31'].join('-')

    holidayAction.getListHoliday({
      startDatetime: startDateString,
      endDatetime: endDateString,
      companyId: accountReducer.user.companyId,
      limit: 999,
    })
  }

  componentDidUpdate () {
    const props = { ...this.props }
    const { holidayAction, accountReducer } = props
    let selectedDate = new Date(props.year, props.month - 1, props.date, 0, -new Date().getTimezoneOffset())
    const startDateString = [selectedDate.getFullYear(), '01', '01'].join('-')
    const endDateString = [selectedDate.getFullYear(), '12', '31'].join('-')
    if (selectedDate.valueOf() !== this.state.selectedDate.valueOf()) {
      this.setState({
        selectedDate: selectedDate
      }, () => {
        holidayAction.getListHoliday({
          startDatetime: startDateString,
          endDatetime: endDateString,
          companyId: accountReducer.user.companyId,
          limit: 999
        })
      })
    }
  }

    openModalCrashBooking= () => {
      const {
        modalAction
      } = this.props
        modalAction.openModalCrashBooking()
    }

    openModalInformation = (event, dataInfo) => {
      event.stopPropagation()
      event.preventDefault()
      const {
        modalAction
      } = this.props
      this.setState({
        headerName: dataInfo.headerName,
        descriptionName: dataInfo.descriptionName,
        buttonName: dataInfo.buttonName,
      }, () => {
        modalAction.openModalInformation()
      })
    }
  
    openModalConfirm = () => {
      const {
        modalAction
      } = this.props
      modalAction.openModalConfirm()
    }

  getTotalDayInMonth (month = (new Date()).getMonth(), year = (new Date()).getFullYear()) {
    return 32 - (new Date(year, month, 32)).getDate()
  }

  goToCreateBookingDate (props, date, type) {
    const { permission } = this.state
    const { holidayReducer } = this.props
    this.closeModal()
    if (type === 1) {
      let selectedDate = new Date(props.selectDate.getFullYear(), props.selectDate.getMonth(), date, 0, -new Date().getTimezoneOffset())
      const dateString = [selectedDate.getFullYear(), (selectedDate.getMonth() + 1).toString().padStart(2, 0), selectedDate.getDate().toString().padStart(2, 0)].join('-')
      const isHoliday = holidayReducer.listHoliday.filter((holiday) => new Date(holiday.date).valueOf() === new Date(dateString).valueOf())
      if (isHoliday.length > 0) {
        this.setState({
          dateString, 
        }, () => {
          this.openModalCrashBooking()
        })
      } else {
        if (permission.create) {
          this.props.history.push(`${ROUTE.BOOKING.LINK}?date=${dateString}&from=calendar_month`)
        }
      }
    }
    else if (type === 2) {
      let selectedDate = new Date(props.selectDate.getFullYear(), props.selectDate.getMonth() + 1, date, 0, -new Date().getTimezoneOffset())
      const dateString = [selectedDate.getFullYear(), (selectedDate.getMonth() + 1).toString().padStart(2, 0), selectedDate.getDate().toString().padStart(2, 0)].join('-')
      const isHoliday = holidayReducer.listHoliday.filter((holiday) => new Date(holiday.date).valueOf() === new Date(dateString).valueOf())
      if (isHoliday.length > 0) {
        this.setState({
          dateString, 
        }, () => {
          this.openModalCrashBooking()
        })
      } else {
        if (permission.create) {
          this.props.history.push(`${ROUTE.BOOKING.LINK}?date=${dateString}&from=calendar_month`)
        }
      }
    } else if (type === 0) {
      let selectedDate = new Date(props.selectDate.getFullYear(), props.selectDate.getMonth() - 1, date, 0, -new Date().getTimezoneOffset())
      const dateString = [selectedDate.getFullYear(), (selectedDate.getMonth() + 1).toString().padStart(2, 0), selectedDate.getDate().toString().padStart(2, 0)].join('-')
      const isHoliday = holidayReducer.listHoliday.filter((holiday) => new Date(holiday.date).valueOf() === new Date(dateString).valueOf())

      if (isHoliday.length > 0) {
        this.setState({
          dateString, 
        }, () => {
          this.openModalCrashBooking()
        })
      } else {
        if (permission.create) {
          this.props.history.push(`${ROUTE.BOOKING.LINK}?date=${dateString}&from=calendar_month`)
        }
      }
    }

  }

  goToCreateBooking () {
    const { holidayReducer } = this.props
    const { selectedDate } = this.state
    this.closeModal()
    const dateString = [selectedDate.getFullYear(), (selectedDate.getMonth() + 1).toString().padStart(2, 0), selectedDate.getDate().toString().padStart(2, 0)].join('-')
    const isHoliday = holidayReducer.listHoliday.filter((holiday) => new Date(holiday.date).valueOf() === new Date(dateString).valueOf())
    if (isHoliday.length > 0) {  
        this.openModalCrashBooking()
    } else {
      this.props.history.push(`${ROUTE.BOOKING.LINK}?date=${dateString}&from=calendar_month`)
    }
    this.trackingCreateButton()
  }

  trackingCreateButton () {
    ReactGA.event({
      category: "Month Calendar",
      action: "Create_Button",
    })
  }

  createBooking = (dateString) => {
    this.closeModal()
    this.props.history.push(`${ROUTE.BOOKING.LINK}?date=${dateString}&from=calendar_month`)
  }

  objGetParams = () => {
    const month = this.props.match.params.month
    const year = this.props.match.params.year
    const {
      trashed,
      limit,
      ownerName,
    } = this.state
    const lastDayOfThisMonth = this.getTotalDayInMonth(month - 1, year)
    const statedate = new Date(year, month - 1, -6)
    const enddate = new Date(year, month - 1, lastDayOfThisMonth + 6)
    const startTime = `${moment(statedate).format('YYYY-MM-DD')} 00:00:00`
    const endTime = `${moment(enddate).format('YYYY-MM-DD')} 23:59:59`

    return {
      trashed,
      limit,
      username: ownerName,
      companyId: this.props.accountReducer.user.companyId,
      isIncludeChildBooking: false,
      startDatetime: startTime,
      endDatetime: endTime,
      status: JSON.stringify([0, 1, 2]),
      sorts: JSON.stringify([
        {
          type: 'ASC',
          column: 'startDatetime',
        }
      ]),
    }
  }

  objGetParams2 = (location) => {
    const obj = location.pathname.split('/')
    const month = obj[4]
    const year = obj[3]
    const {
      trashed,
      limit,
      ownerName,
    } = this.state
    const lastDayOfThisMonth = this.getTotalDayInMonth(month - 1, year)
    const statedate = new Date(year, month - 1, -6)
    const enddate = new Date(year, month - 1, lastDayOfThisMonth + 6)
    const startTime = `${moment(statedate).format('YYYY-MM-DD')} 00:00:00`
    const endTime = `${moment(enddate).format('YYYY-MM-DD')} 23:59:59`

    return {
      trashed,
      limit,
      username: ownerName,
      companyId: this.props.accountReducer.user.companyId,
      isIncludeChildBooking: false,
      startDatetime: startTime,
      endDatetime: endTime,
      status: JSON.stringify([0, 1, 2]),
      sorts: JSON.stringify([
        {
          type: 'ASC',
          column: 'startDatetime',
        }
      ]),
    }
  }

  onClickDetail = (event, res) => {
    const { language = 'EN' } = this.props.accountReducer
    const { modalAction } = this.props

    event.stopPropagation()
    event.preventDefault()

    const { bookingData } = this.state

    if (bookingData.length > 0) {
      if (bookingData[0].id !== res.id) {
        setTimeout(() => {
          this.closeModal()
          modalAction.openBookingDetailModal()
        }, 200)
      }
    }

    let startTime = res.startDatetime.split('T')
    startTime = startTime[1].split(':')
    startTime = startTime[0] + '.' + startTime[1]
    let endTime = res.endDatetime.split('T')
    endTime = endTime[1].split(':')
    endTime = endTime[0] + '.' + endTime[1]

    let start = startTime
    let end = endTime

    const startDatetime = new Date(res.startDatetime.replace('Z', ''))

    const mapValue = {
      id: res.id,
      title: res.projectName,
      day: getCalendarString(startDatetime, language),
      location: res.roomName,
      startTime: start,
      time: `${start} - ${end}`,
      description: res.description || CREATE_BOOKING.NO_DATA[this.props.accountReducer.language],
      status: res.status,
      owner: res.owner,
      recurrence: res.recurrence,
      meetingLink: res.meetingLink,
      meetingLinkType: res.meetingLinkType,
      isEditable: res.isEditable
    }

    modalAction.openBookingDetailModal()

    this.setState({
      position: getPositionBookingCard({ event, isMore: false }),
      itemId: res.id,
      nameModal: res.projectName,
      bookingData: [mapValue],
      date: res.startDatetime,
    })
  }

  setItemId = (itemId) => {
    this.setState({ itemId: itemId })
  }

  onClickMore = (event, res) => {
    const { language = 'EN' } = this.props.accountReducer
    const { modalAction } = this.props

    event.stopPropagation()
    event.preventDefault()
    const { bookingData } = this.state

    if (bookingData.length > 0) {
      if (bookingData[0].id !== res.id) {
        setTimeout(() => {
          this.closeModal()
          modalAction.openBookingMoreDetailModal()
        }, 200)
      }
    }

    const mapValue = res.map((item, index) => {
      let startTime = item.startDatetime.split('T')
      startTime = startTime[1].split(':')
      startTime = startTime[0] + '.' + startTime[1]
      let endTime = item.endDatetime.split('T')
      endTime = endTime[1].split(':')
      endTime = endTime[0] + '.' + endTime[1]

      let start = startTime
      let end = endTime

      const startDatetime = new Date(item.startDatetime.replace('Z', ''))

      return {
        id: item.id,
        title: item.projectName,
        day: getCalendarString(startDatetime, language),
        location: item.roomName,
        startTime: start,
        time: `${start} - ${end}`,
        detail: item.owner,
        status: item.status,
        description: item.description || CREATE_BOOKING.NO_DATA[this.props.accountReducer.language],
        owner: item.owner,
        recurrence: item.recurrence,
        meetingLink: item.meetingLink,
        meetingLinkType: item.meetingLinkType,
        isEditable: item.isEditable
      }
    })

    modalAction.openBookingMoreDetailModal()

    this.setState({
      position: getPositionBookingCard({ event, isMore: true, isYear: false }),
      bookingData: mapValue,
      date: res[0].startDatetime,
    })
  }

  closeModal = () => {
    const { modalAction } = this.props

    modalAction.closeBookingDetailModal()
    modalAction.closeBookingMoreDetailModal()
    modalAction.closeModalCrashBooking()
    modalAction.closeModalInformation()
  }

  deleteBooking = () => {
    const { itemId } = this.state
    const { modalAction } = this.props
    this.setState({ bookingId: itemId })
    modalAction.openModalConfirm()
  }

  render () {
    const props = this.props
    const dateNew = new Date(this.props.year, this.props.month - 1, this.props.date)
    const { colorTheme } = this.props.settingReducer.settingTheme

    const { 
      bookingcalendarReducer,
      loaderReducer,
      history,
      accountReducer,
      modalReducer,
      modalAction,
      bookingcalendarAction
    } = this.props

    const {
      bookingData,
      nameModal,
      date,
      permission,
      position,
      dateString,
      headerName,
      descriptionName,
      buttonName
    } = this.state
    const { isOpenBookingDetailModal, isOpenBookingMoreDetailModal } = modalReducer

    const isOpenBookingModal = isOpenBookingDetailModal || isOpenBookingMoreDetailModal
    const typeModal = isOpenBookingDetailModal ? BOOKING_DETAIL_VIEW.BOOKING_VIEW : BOOKING_DETAIL_VIEW.MORE_VIEW

    const displayContent = (
      <StyleMonth>
        {(props.modalReducer.status && !props.modalReducer.status.status) &&
          <ModalStatus
            language={accountReducer.language}
            code={props.modalReducer.status.code}
            action={props.modalReducer.status.status
              ? `${CREATE_DEFAULT.EDIT[accountReducer.language]}${MODAL_STATUS.COMPLELTE[accountReducer.language]}`
              : MODAL_STATUS.WARNING[accountReducer.language]}
            text={props.modalReducer.status.status
              ? MODAL_STATUS.SUCCESS[accountReducer.language]
              : props.modalReducer.status.data.description}
            status={props.modalReducer.status.status}
            onClick={props.modalAction.closeModalStatus}
            colorTheme={colorTheme}
          />}
        {
          permission.create &&
          <ButtonCreate {...this.props} onClick={() => { this.goToCreateBooking() }} />
        }
        {loaderReducer.isDisplay ? <Loader colorTheme={colorTheme} /> : null}
        <div className='body'>
          {!loaderReducer.isDisplay && bookingcalendarReducer.list !== null &&
            <MonthPicker
              {...this.props}
              colorTheme={colorTheme}
              bookingcalendarReducer={bookingcalendarReducer}
              isShowing={true}
              selectDate={dateNew}
              startSelectable={dateNew}
              tempDate={dateNew}
              language={props.accountReducer.language}
              showArrow={false}
              onClickDetail={this.onClickDetail}
              onClickInformation={(event, dataInfo) => this.openModalInformation(event, dataInfo)}
              onClickMore={this.onClickMore}
              goToCreateBookingDate={(e, t, s) => this.goToCreateBookingDate(e, t, s)}
              history={this.props.history}
            />
          }

          {modalReducer.isOpenModalCrashBooking && <ModalCrashBooking
            language={accountReducer.language}
            colorTheme={colorTheme}
            onClickAction={()=>this.createBooking(dateString)}
            onClickCancel={this.closeModal}
          />}

          {modalReducer.isOpenModalInformation && <ModalInformation
            headerName={headerName}
            colorTheme={colorTheme}
            descriptionName={descriptionName}
            buttonName={buttonName}
            onClick={this.closeModal}
          />}

          {isOpenBookingModal ?
            <ModalBookingList
              colorTheme={props.settingReducer.settingTheme.colorTheme}
              bookings={bookingData}
              history={history}
              date={date}
              typeModal={typeModal}
              position={position}
              language={accountReducer.language}
              closeModal={this.closeModal}
              deleteBooking={this.deleteBooking}
              setItemId={this.setItemId}
              permission={accountReducer.permission}
              isFloorPlan={false}
              modalReducer={modalReducer}
              modalAction={modalAction}
              companyTokenType={accountReducer.profile.companyTokenType}
              bookingcalendarAction={bookingcalendarAction}
              nameModal={nameModal}
              objGetParams={this.objGetParams}
              onClickInformation={(event, dataInfo) => this.openModalInformation(event, dataInfo)}
              onClickConfirm={() => this.openModalConfirm()}
            /> 
            : null
          }
        </div>
      </StyleMonth>
    )

    return (
      checkPermission(accountReducer.permission, ROUTE.CALENDAR.CODE)
        ? displayContent : <div style={{ margin: 'auto' }}>{PERMISSION_PAGE.NOT_FOUND[accountReducer.language]}</div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    bookingcalendarAction: bindActionCreators(BOOKINGCALENDAR.action, dispatch),
    modalAction: bindActionCreators(MODAL.action, dispatch),
    holidayAction: bindActionCreators(HOLIDAY.action, dispatch),
  }
}

export const mapStateToProps = ({ accountReducer, settingReducer, loaderReducer, bookingcalendarReducer, modalReducer, holidayReducer }) => {
  return {
    accountReducer,
    settingReducer,
    loaderReducer,
    bookingcalendarReducer,
    modalReducer,
    holidayReducer
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Month)
